import "./App.css";
import {
	BrowserRouter as Router,
	Navigate,
	Outlet,
	Route,
	Routes,
} from "react-router-dom";
import { useAppSelector } from "./app/hooks";
import Landing from "./common/Landing";
import Main from "./common/Main";
import Navbar from "./common/Navbar";
import ErrorPage from "./components/ErrorPage";
import Register from "./Login/Register";
import Reset from "./Login/Reset";
import SignIn from "./Login/SignIn";

interface ProtectedRouteProps {
	isAuth: boolean;
	redirectPath?: string;
}

const ProtectedRoute = ({
	isAuth,
	redirectPath = "/",
}: ProtectedRouteProps) => {
	if (!isAuth) {
		return <Navigate to={redirectPath} replace />;
	}
	return <Outlet />;
};

function App() {
	const isAuth = useAppSelector((state) => state.login.isAuth);

	return (
		<Router>
			<div className="app-shell">
				<div className="app-background" aria-hidden />
				<Navbar />
				<main className="app-main">
					<Routes>
						<Route index element={<Landing />} />
						<Route path="landing" element={<Landing />} />
						<Route path="login" element={<SignIn />} />
						<Route path="register" element={<Register />} />
						<Route path="reset" element={<Reset />} />
						<Route path="error" element={<ErrorPage />} />
						<Route element={<ProtectedRoute isAuth={isAuth} />}>
							<Route path="dashboard" element={<Main />} />
						</Route>
					</Routes>
				</main>
			</div>
		</Router>
	);
}

export default App;
